import { render, staticRenderFns } from "./VFormPublic.vue?vue&type=template&id=cbec8e02"
import script from "./VFormPublic.vue?vue&type=script&lang=js"
export * from "./VFormPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports